import '../../../../Styles/Toyota.scss'

import React from 'react';
import { Link } from 'react-router-dom';

import Image from 'react-bootstrap/Image';
import ResendLink from '../../Shared/ResendLink';
import ToyotaLogo from '../../../../static/images/Toyota-Logo.svg'
import Loader from '../../../../static/images/loading.gif'
import AppVars from '../../../../AppVars.js'
import Logger from '../../../../Logger.js';
import { constants } from '../../../../constants/constants';

const appVars = AppVars.getInstance();

class ActivateSuccessView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
        }
    }

    render() {
        return(
            <div>
                <div role = "banner">
                 <div>
                    <Image className="login-log-resend" src={ToyotaLogo}/>
                </div>
                <div className="block title__TO" style={{'marginBottom': '39x', 'marginTop': '170px', 'width':'auto'}}>
                    {constants.ACTIVATE_SUCCESS_TITLE}
                </div>
                </div>
                {/* BODY OF THE COMPONENT */}
                <div className="body-container__TO">
                    <div className="responsive" role="main">
                         
                        {/* SUCCESSFUL ACTIVATION */}
                        <div>
                            <div className="subtitleTO" >
                                Please click below to sign in.
                            </div>
                            <Link to = {this.props.redirectURI}><button style={{'marginTop' : '15px'}} className="button__TO">Sign In</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default ActivateSuccessView
